/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceConnectionInvite
 */
export interface WorkspaceConnectionInvite {
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkspaceConnectionInvite
     */
    emails: Array<string>;
}

export function WorkspaceConnectionInviteFromJSON(json: any): WorkspaceConnectionInvite {
    return WorkspaceConnectionInviteFromJSONTyped(json, false);
}

export function WorkspaceConnectionInviteFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceConnectionInvite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emails': json['emails'],
    };
}

export function WorkspaceConnectionInviteToJSON(value?: WorkspaceConnectionInvite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emails': value.emails,
    };
}

